import { useEffect, useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { Alert } from "@mui/material";
import { api, getErrorMessage } from "../api/client";
import { useAuth } from "../contexts/AuthContext";
import AuthCard from "../components/AuthCard";
import TotpInput from "../components/TotpInput";

export default function SsoMfaPage() {
  const { refreshUser } = useAuth();
  const [code, setCode] = useState("");

  const verify = useMutation({
    mutationFn: async (totp: string) => {
      const result = await api.ssoGoogleMfa(totp);
      await refreshUser();
      return result;
    },
    meta: { suppressErrorToast: true },
    onSuccess: (result) => window.location.assign(result.redirect_to || "/"),
  });

  useEffect(() => {
    if (code.replace(/\s/g, "").length === 6) verify.mutate(code);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [code]);

  return (
    <AuthCard title="Two-step verification" subtitle="Enter your authenticator code to finish signing in">
      {verify.error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {getErrorMessage(verify.error)}
        </Alert>
      )}
      <TotpInput value={code} onChange={setCode} autoFocus disabled={verify.isPending} error={verify.isError && code.length === 6} />
    </AuthCard>
  );
}
